import { render, staticRenderFns } from "./header.html?vue&type=template&id=2f913065&scoped=true&"
import script from "./header.js?vue&type=script&lang=js&"
export * from "./header.js?vue&type=script&lang=js&"
import style0 from "./header.css?vue&type=style&index=0&id=2f913065&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f913065",
  null
  
)

export default component.exports